module.exports = __webpack_public_path__ + "a78b2c7e77b113402423b0e5ff0aa788.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1090
// module chunks = 0